import GenericFormModalContainer from "../../../../components/TailwindControls/Modals/FormModal/GenericFormModalContainer";
import FormStepper from "../../crm/shared/components/FormStepper";
import { Formik } from "formik";
import React from "react";
import { ICRMInstance } from "../../../../models/Accounts";
import { TFunction } from "next-i18next";
import {
  instanceAddStepOneImage,
  instanceComputerScreenStyle,
} from "../../../../shared/themeHelper/themeHelperfunc";
import { useBaseDomain } from "../../../../shared/context/RuntimeConfigContext";

export function InstanceAddStepOneForm(props: {
  renderFullPage: boolean;
  formHeading: string | undefined;
  steps: ({ label: string } | { label: string } | { label: string })[];
  activeStep: number;
  s: TFunction | string;
  internalInstance: Partial<ICRMInstance>;
  formArray: Record<string, any>;
  validationSchema: any;
  onOutsideClick: (value: boolean) => void;
  onNextClick: (values: Record<string, any>) => void;
  element: ({
    handleSubmit,
    handleChange,
  }: {
    handleSubmit: any;
    handleChange: any;
  }) => JSX.Element;
}) {
  const baseDomain = useBaseDomain();
  return (
    <GenericFormModalContainer
      renderFullPage={props.renderFullPage}
      topIconType="MoreInfo"
      formHeading={props.formHeading}
      infoArray={[
        {
          label: "Instance",
          value:
            "An instance is like a database or a group of applications required for running your business. Enter a name that suits your business",
        },
      ]}
      onOutsideClick={props.onOutsideClick}
      useModalFormInUrl={true}
    >
      <div className="w-full max-h-[60vh] overflow-y-auto pr-1.5 card-scroll mt-8 flex flex-col items-center">
        <FormStepper steps={props.steps} activeStep={props.activeStep} />
        <img
          src={instanceAddStepOneImage(baseDomain)}
          alt="Computer Screen"
          className={`w-44 mt-9 ${instanceComputerScreenStyle(baseDomain)}`}
        />
        <div className="w-44 mt-6.5 mb-4 text-center ">
          <span className="text-vryno-message text-sm">
            <>{props.s}</>
          </span>
        </div>
        <form onSubmit={(e) => e.preventDefault()} className="w-full">
          <Formik
            initialValues={{
              name: props.internalInstance.name || props.formArray["name"],
            }}
            validationSchema={props.validationSchema}
            onSubmit={props.onNextClick}
          >
            {props.element}
          </Formik>
        </form>
      </div>
    </GenericFormModalContainer>
  );
}
